import { internalApi } from "@circle-react/helpers/urlHelpers";

import { reactQueryGet } from "@/react/helpers/backendRequestHelpers";

export interface MetricsResponse {
  average_connections_per_member: number;
  connectedness: number;
  new_connections: number;
  total_active_connections: number;
}

export interface ConnectorResponse extends CommunityMember {
  active_connections_count: number;
}

export interface TopConnectorsResponse {
  top_connectors: ConnectorResponse[];
}

interface CommunityMember {
  avatar_url: string;
  headline?: string;
  id: string;
  name: string;
  public_uid: string;
}

export const ConnectionStatus = {
  PENDING: "pending",
  DETACHED: "detached",
  IGNORED: "ignored",
  WITHDRAWN: "withdrawn",
  ACTIVE: "active",
} as const;

export interface ConnectionInitiator {
  admin: boolean;
  avatar_url: string;
  created_at: string;
  first_name: string;
  headline: string;
  id: number;
  is_deleted: boolean;
  last_name: string;
  name: string;
  profile_confirmed_at: string;
  public_uid: string;
  sqid: string;
  user_attachable_sgid: string;
  user_id: number;
}

export interface ConnectionResponse {
  accepted_at?: string;
  created_at: string;
  id: string;
  initiator: ConnectionInitiator;
  is_flagged_for_moderation?: boolean;
  note?: string;
  recipient: ConnectionInitiator;
  status: (typeof ConnectionStatus)[keyof typeof ConnectionStatus];
}

export const connectionsApi = () => {
  const getMetrics = () =>
    reactQueryGet<MetricsResponse>(internalApi.admin.connections.metrics());

  const getTopConnectors = (limit?: number) =>
    reactQueryGet<TopConnectorsResponse>(
      internalApi.admin.connections.topConnectors(limit),
    );

  const getLatestConnections = (page?: number, per_page: number = 10) =>
    reactQueryGet(
      internalApi.admin.connections.latestConnections(page, per_page),
    );

  return {
    getMetrics,
    getTopConnectors,
    getLatestConnections,
  };
};
